import { render, staticRenderFns } from "./GroupMenuHeader.vue?vue&type=template&id=54d4ccb3"
import script from "./GroupMenuHeader.vue?vue&type=script&lang=js"
export * from "./GroupMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./GroupMenuHeader.vue?vue&type=style&index=0&id=54d4ccb3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports